export default {
    data () {
        return {
            show_unread_list: false
        }
    },
    methods: {
        showUnreadList () {
            this.show_unread_list = true
            this.$sendCtmEvtLog(`消息列表-只看未读点击`)
        }
    }
}